import React from 'react';
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

//  IMPORTANT: I am reverting to the asset imports you originally provided.
import necklace from '../../assests/collectionImg/necklace.jpg';
import earing from '../../assests/collectionImg/earing.jpg';
import ring from '../../assests/collectionImg/ring.webp';
import bangle from '../../assests/collectionImg/bangle.webp';
import man_weslet from '../../assests/collectionImg/man weslet.jpeg';
import mangalsutra from '../../assests/collectionImg/mangalsutra.jpg';
import maag_tikka from '../../assests/collectionImg/maag tikka.jpeg';
import sadi_pin from '../../assests/collectionImg/sadi pin.webp';
import juda from '../../assests/collectionImg/juda.webp';
import hath_pan from '../../assests/collectionImg/hath pan.jpg';

// Custom Arrows
const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div
      className="absolute z-10 right-0 top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow hover:bg-gray-200 cursor-pointer"
      onClick={onClick}
    >
      <ChevronRight size={24} />
    </div>
  );
};

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div
      className="absolute z-10 left-0 top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow hover:bg-gray-200 cursor-pointer"
      onClick={onClick}
    >
      <ChevronLeft size={24} />
    </div>
  );
};

// Collection Card Component
const CollectionCard: React.FC<{ label: string; image: string }> = ({ label, image }) => {
  return (
    // The link will be applied externally by the parent <a> tag
    <div className="w-full flex flex-col items-center text-center mx-2 sm:mx-3 my-4 group transition-transform duration-300 ease-in-out"> 
      <div className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-44 lg:h-44 rounded-full border-[2px] border-yellow-800 shadow-[0_4px_20px_rgba(218,165,32,0.4)] overflow-hidden transition-transform duration-500 ease-in-out transform group-hover:scale-110">
        <img
          src={image}
          alt={label}
          className="w-full h-full object-cover object-center transition-transform duration-500 ease-in-out transform group-hover:scale-125"
        />
      </div>
      <p className="mt-3 text-sm sm:text-base md:text-[16px] font-semibold text-gray-800">{label}</p>
    </div>
  );
};

const CollectionPage = () => {
  // 🛑 CORRECTION: The array now holds the correct image paths and a `link` property.
  const categories = [
    { label: 'Necklace', image: necklace, link: '/necklaces' },
    { label: 'Earrings', image: earing, link: '/earrings' },
    { label: 'Ring', image: ring, link: '/rings' },
    { label: 'Bangles', image: bangle, link: '/bangles' },
    { label: 'Hath Pan', image: hath_pan, link: '/hathpan' },
    { label: 'Bracelet', image: man_weslet, link: '/bracelets' },
    { label: 'Mangalsutra', image: mangalsutra, link: '/Mangalsutra' },
    { label: 'Mang Tikka', image: maag_tikka, link: '/maangtikka' },
    { label: 'Sadi Pin', image: sadi_pin, link: '/sadipin' },
    { label: 'Juda', image: juda, link: '/juda' },
  ];

  // Removed createSlug as we are using direct links from the categories array

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
   
    <div className="py-8 bg-white"> 
      <h2 className="text-center text-2xl sm:text-3xl font-semibold mb-6 font-[Cinzel] bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 bg-clip-text text-transparent py-5">
        Discover Our Collections
      </h2>

      
      <div className="relative"> 
        <Slider {...settings}>
        {categories.map((item, index) => {
            // Using the explicit 'link' property for the href
            const linkPath = item.link; 
            return (
              <div key={index}>
               
                <a 
                  href={linkPath} 
                  className="block focus:outline-none" 
                  // Adding cursor-pointer explicitly for clear user feedback
                  style={{ cursor: 'pointer' }} 
                >
                  <CollectionCard label={item.label} image={item.image} />
                </a>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default CollectionPage;